import { useClinicalCodeTransformations } from "@/clinical-codes-transformations/useClinicalCodeTransformations";
import { TransformationForm } from "@/clinical-codes-transformations/TransformationForm";
import { TransformationList } from "@/clinical-codes-transformations/TransformationList";
import type { Transformation, TransformationFormState } from "@/clinical-codes-transformations/types";
import { useState, useRef } from "react";

const ClinicalCodeTransformationsPage = () => {
  const { updateTransformation, createTransformation } = useClinicalCodeTransformations();

  const [editingTransformation, setEditingTransformation] = useState<Transformation | null>(null);
  const [showForm, setShowForm] = useState(false);
  const formRef = useRef<HTMLDivElement>(null);

  const handleEdit = (transformation: Transformation | null) => {
    setEditingTransformation(transformation);
    setShowForm(true);
    setTimeout(() => {
      formRef.current?.scrollIntoView({ behavior: "smooth", block: "start" });
    }, 0);
  };

  const handleFormCancel = () => {
    setEditingTransformation(null);
    setShowForm(false);
  };

  const handleSubmitTransformationForm = (transformation: TransformationFormState) => {
    if (transformation.id) {
      updateTransformation.mutate({
        id: transformation.id,
        formData: transformation,
      });
    } else {
      createTransformation.mutate(transformation);
    }

    setShowForm(false);
  };

  return (
    <div className="space-y-4">
      <div>
        <h1 className="text-3xl font-bold tracking-tight">Clinical Code Transformations</h1>
        <p className="text-muted-foreground">Manage clinical codes transformations</p>
      </div>
      {showForm && (
        <div ref={formRef} className="grid grid-cols-1 md:grid-cols-1 gap-4">
          <div className="max-h-[80vh] overflow-y-auto">
            <TransformationForm
              initialData={editingTransformation ?? undefined}
              onSubmit={handleSubmitTransformationForm}
              onCancel={handleFormCancel}
            />
          </div>
        </div>
      )}
      <TransformationList onEdit={handleEdit} />
    </div>
  );
};

export default ClinicalCodeTransformationsPage;
